export default "__VITE_ASSET__CMYNdftZ__"